import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import NetworkGraph from './NetworkGraph';

const HeroSection: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="network-graph-background">
          <NetworkGraph />
        </div>
      </div>
      <div className="container">
        <div className="hero-content d-flex">
          <div className="text-content">
            <div className="badge-container">
            </div>
            <h1>Credit Scoring Reimagined With Graph Intelligence</h1>
            <p className="hero-subtitle">Modern risk analysis powered by advanced graph technology. Transforming data into actionable insights.</p>
            <div className="hero-buttons">
              <Link to="/industries" className="button-link">
                <button className="secondary-button">Explore Solutions</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-pattern"></div>
    </section>
  );
};

export default HeroSection;